import type { Serwist } from '@serwist/window';
import { useDispatch } from 'react-redux';

import { logger } from '@/config/logger';
import { displayInfoMessage } from '@/modules/messages/services/actions';

export function useHandleUpdate() {
    const dispatch = useDispatch();

    return function handleUpdate(serwist: Serwist) {
        serwist.addEventListener('waiting', () => {
            logger.debug(
                `A new service worker has installed, but it can't activate until all tabs running the current version have fully unloaded or user skips the waiting.`,
            );

            serwist.addEventListener('controlling', () => {
                location.reload();
            });

            dispatch(
                displayInfoMessage({
                    message: { id: 'service-worker.update' },
                    button: {
                        message: {
                            id: 'service-worker.updateBtn',
                        },
                        onClick() {
                            serwist.messageSkipWaiting();
                        },
                    },
                    options: {
                        duration: 0,
                    },
                }),
            );
        });
    };
}
